module.exports = __webpack_public_path__ + "img/nearPay_location.3a14c38e.jpeg";